import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ISystemTransactions } from '~/models/modules/Common/systemTransactions';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({
  providedIn: 'root'
})
export class SystemTransactionsService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.common);
  }

  getAssetTransactions(isEnterprise : boolean = null){
    return this.client.get<ISystemTransactions[]>(this._url(`/asset-transactions/${isEnterprise}`))
  }

  getStockTransactions(isEnterprise : boolean = null){
    return this.client.get<ISystemTransactions[]>(this._url(`/stock-transactions/${isEnterprise}`))
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/SystemTransactions${v}`);
  }
}
